var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.modalShow,
          expression: "modalShow"
        }
      ],
      staticClass: "h-vertical-align-container"
    },
    [
      _c("div", {
        staticClass: "modal__overlay",
        on: {
          click: function($event) {
            _vm.closeModal()
          }
        }
      }),
      _c(
        "div",
        { staticClass: "modal__wrapper modal__wrapper--marketingConsent" },
        [
          _c("div", { staticClass: "modal__marketingconsent" }, [
            _c("h1", [_vm._v("Add your watermarks in the app!")]),
            _c(
              "div",
              { staticClass: "marketingConsent--container" },
              [
                _c("p", [
                  _vm._v(
                    "The latest versions of Cinemagraph Pro and Cinemagraph Pro for iOS now allow you to add images to your cinemagraphs!"
                  )
                ]),
                _c("download-trial-button", {
                  attrs: {
                    product: "pro",
                    classes: "btn btn--blue btn--download",
                    copy: "Download"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-549a2ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549a2ea8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watermarkWarning.vue
// module id = null
// module chunks = 